import { createSelector } from 'reselect';

const sessionClipsSelector = (state) => state.playbackSession.clips;

const triviaCurrentSessionClip = createSelector([sessionClipsSelector], (clips = []) => clips[0]);

export const triviaCurrentSessionClipSelector = createSelector(
  [triviaCurrentSessionClip],
  (clip = {}) => clip,
);
